// extracted by mini-css-extract-plugin
export var copyright = "footer-module--copyright--e8572";
export var footer = "footer-module--footer--051a5";
export var footerLinks = "footer-module--footerLinks--8c427";
export var footerLogos = "footer-module--footerLogos--bfdf7";
export var footerSocialLinks = "footer-module--footerSocialLinks--70289";
export var legalLinks = "footer-module--legalLinks--7c256";
export var siteMap = "footer-module--siteMap--d7c74";
export var siteMapLogo = "footer-module--siteMapLogo--1ba25";